import Axios from "axios";
import { action, decorate, observable } from "mobx";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { convertTextToID } from "../../../../utils/GlobalFunction";
import moment from "moment";

export default class ManageBillInvoicesStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	editValues = null;
	viewValues = null;
	total = 0;
	allColumnIds = [];
	dropdown_center_list = null;
	daliyBookingValues = null;
	searchAgGrid = null
	search_per_page = ServerGridConfig.options.paginationPageSize;
	search_filter = null


	// set form values to view
	setViewValues = (data) => {
		this.viewValues = data;
	};

	// set form values to view
	setDaliyBookingValues = (data) => {
		this.daliyBookingValues = data;
	};


	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
			this.agGrid.api.setFilterModel({
				issue_date: { dateFrom: moment().startOf('months').format("YYYY-MM-DD"), dateTo: moment().format("YYYY-MM-DD"), type: "inRange", filterType: "date" }
			});
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	setupSearchGrid = (params) => {
		this.searchAgGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	}

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	setSearchPageSize = (page = this.search_per_page) => {
		this.search_per_page = page
		if(this.searchAgGrid) {
			this.searchAgGrid.api.paginationSetPageSize(parseInt(page))
		}
	}

	// call api to get records
	getList = (payload) => {
		return Axios.post(`/monthly-activities/client-invoices/invoice-list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					//     item.cities = item.cities && item.cities.name
					return null;
				});
			}
			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			return data;
		});
	};

	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;

		if (final_filter["is_active"]) {
			final_filter['is_active'].values = convertTextToID(final_filter['is_active'], this.isActiveFilterList, 'name', 'id')
		}

		return { final_filter, final_sort };
	};

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	onFilterChangedSearch = (params) => {
		this.searchAgGrid = params;
		if (this.searchAgGrid && this.searchAgGrid.api.getModel().getRowCount() === 0) {
			this.searchAgGrid.api.showNoRowsOverlay();
		}
		if (this.searchAgGrid && this.searchAgGrid.api.getModel().getRowCount() > 0) {
			this.searchAgGrid.api.hideOverlay();
		}
	};

	  generatePayload = (filter) => {
        return filter;
    }

	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var payload = {
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					page: Math.ceil(
						(params.request.startRow + 1) /
						(params.request.endRow - params.request.startRow)
					),
				};
				if(this.search_filter) {
					payload.advance_filter = this.generatePayload(this.search_filter)
				}
				this.search_filter ? this.getList(payload).then((data) => {
					if (data.list.total === 0) {
						this.searchAgGrid.api.showNoRowsOverlay();
					} else {
						this.searchAgGrid.api.hideOverlay();
					}
					params.successCallback(data.list.data, data.list.total);
					var allColumnIds = [];
					if (this.searchAgGrid && this.searchAgGrid.columnApi && data.total) {
						this.searchAgGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.col_id);
						});
					}
				}) :
					this.getList(payload).then((data) => {
						if (data.list.total === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.successCallback(data.list.data, data.list.total);
						var allColumnIds = [];
						if (this.agGrid && this.agGrid.columnApi && data.total) {
							this.agGrid.columnApi.getAllColumns().forEach(function (column) {
								allColumnIds.push(column.col_id);
							});
						}
					});
			},
		};
	};

	setSearchFilterValues = (data = null) => {
        return new Promise((resolve) => {
            this.search_filter = data;
            if (this.searchAgGrid && data) {
                this.setupSearchGrid(this.searchAgGrid);
            }
            resolve()
        });
    };

	refreshList = () => {
		if (this.agGrid) {
			this.setupGrid(this.agGrid);
		}
	}

	refreshSearchList = () => {
		if (this.searchAgGrid) {
			this.setupSearchGrid(this.searchAgGrid);
		}
	}

}

decorate(ManageBillInvoicesStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	editValues: observable,
	total: observable,
	allColumnIds: observable,
	setupGrid: action,
	setPageSize: action,
	getList: action,
	onFilterChanged: action,
	setViewValues: action,
	viewValues: observable,
	setEditValues: action,
	setIsActiveFilterList: action,
	isActiveFilterList: observable,
	setDaliyBookingValues: action,
	daliyBookingValues: observable,
	searchAgGrid : observable,
	search_per_page : observable,
	setupSearchGrid : action,
	setSearchPageSize : action,
	onFilterChangedSearch: action,
	setSearchFilterValues : action,
	refreshSearchList : action

});
